import { Grid, Typography, Box } from "@mui/material";
import React from "react";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

const LeftFooter = () => {
  return (
    <Grid item xs={12} md={4}>
      <Box sx={{ textAlign: "left" }}>
        <Typography
          variant="h5"
          gutterBottom
          sx={{
            fontWeight: 700,
            color: "#ffffff",
            mb: 2.5,
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <AccessTimeIcon sx={{ fontSize: "1.8rem", color: "#ffffff" }} />
          שעות פעילות
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              borderBottom: "1px dashed rgba(255,255,255,0.2)",
              pb: 1,
            }}
          >
            <Typography
              variant="body1"
              sx={{ fontWeight: 500, color: "#e3f2fd" }}
            >
              07:00 - 18:00
            </Typography>
            <Typography variant="body1" sx={{ color: "#ffffff" }}>
              ראשון - חמישי
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              borderBottom: "1px dashed rgba(255,255,255,0.2)",
              pb: 1,
            }}
          >
            <Typography
              variant="body1"
              sx={{ fontWeight: 500, color: "#e3f2fd" }}
            >
              סגור
            </Typography>
            <Typography variant="body1" sx={{ color: "#ffffff" }}>
              שישי
            </Typography>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography
              variant="body1"
              sx={{ fontWeight: 500, color: "#e3f2fd" }}
            >
              07:00 - 18:00
            </Typography>
            <Typography variant="body1" sx={{ color: "#ffffff" }}>
              שבת
            </Typography>
          </Box>
        </Box>
      </Box>
    </Grid>
  );
};

export default LeftFooter;
